import { apiFactory } from "../api_factory";

export const generateOtpCodeApi = apiFactory({
  path: "/debug/otp/generate_pin"
});

export const enterOtpCodeApi = apiFactory({
  path: "/debug/otp/enter_pin"
});
